import $ from "jquery";

// Feature detection
const supportsXhrUploads = !!(window.XMLHttpRequestUpload && window.FileReader);
const supportsFormData = !!window.formData;

// Upload a file using XR, returning a jquery promise
//
// options:
//   url: URL to upload to
//   method: HTTP method to use
//   formData: additional form data to include
//   file: File object
//   param: Param name for file
//   progress: Callback for upload progress
//   dataType: data type of the response
export const xhrfileupload = function (options) {
  const formData = options.formData || new FormData();
  formData.append(options.param, options.file);

  const xhr_options = {
    url: options.url,
    type: options.method,
    data: formData,
    contentType: false,
    processData: false,
    dataType: options.dataType || "json",
  };

  if (options.progress) {
    xhr_options.xhr = function () {
      const my_xhr = $.ajaxSettings.xhr();
      if (my_xhr.upload) {
        my_xhr.upload.addEventListener("progress", options.progress, false);
      }
      return my_xhr;
    };
  }

  return $.ajax(xhr_options);
};
